import firebase from "firebase/compat/app";
import {db} from "../../firebase";
import {StudentSoftSkillAnswerInterface, StudentSoftSkillInterface} from "../../db/models/student/softSkill";
import {calculateSoftSkills} from "../../helpers/misc";
import {getUid} from "../auth";
import {Collections} from "../collections";

export const getStudentSoftSkillsListener = (studentId, callback) => {
    if (!studentId) return;

    return db.collection(Collections.STUDENT_CVS).doc(studentId).collection(Collections.STUDENT_SOFT_SKILLS)
        .orderBy("created", "desc")
        .limit(1)
        .onSnapshot(snapshot => {
            let res: StudentSoftSkillInterface[] = [];
            snapshot.docs.forEach((doc) => res.push(doc.data() as StudentSoftSkillInterface));
            const soft = res.length > 0 ? res[0] : null;
            callback(soft);
        });
}

export const addStudentSoftSkills = (answers: StudentSoftSkillAnswerInterface[], assessmentId: string, answerChoiceNumber: number = 4) => {
    const uid = getUid();
    if (!uid || !answers || answers.length === 0 || !assessmentId) return Promise.reject("Bad params");

    const doc = {
        studentId: uid,
        assessmentId,
        answers,
        created: firebase.firestore.FieldValue.serverTimestamp(),
        answerChoiceNumber
    }

    const batch = db.batch();
    const cvRef = db.collection(Collections.STUDENT_CVS).doc(uid);
    const softRef = cvRef.collection(Collections.STUDENT_SOFT_SKILLS).doc();

    // set doc with Assessment answers
    batch.set(softRef, doc);

    // compute soft skills values and update student cv
    const softSkills = calculateSoftSkills(answers, answerChoiceNumber);
    batch.set(cvRef, {softSkills, id: uid}, {merge: true});

    return batch.commit();
};

export const getStudentSoftSkills = (studentId) => {
    if (!studentId) return;

    return db.collection(Collections.STUDENT_CVS).doc(studentId).collection(Collections.STUDENT_SOFT_SKILLS)
        .orderBy("created", "desc")
        .limit(1)
        .get()
        .then(docs => {
            let res: StudentSoftSkillInterface[] = [];
            docs.forEach((doc) => res.push(doc.data() as StudentSoftSkillInterface));
            return res.length > 0 ? res[0] : null;
        })
}